import find from "lodash/find";
import intersection from "lodash/intersection";
import map from "lodash/map";

export const getUserStudio = (state) => {
    const currentStudio = state.appState.currentStudio;
    const userProfile = state.user.userProfile;

    if (currentStudio && userProfile.userStudios) {
        return find(userProfile.userStudios, usrStudio => usrStudio.studio.id === currentStudio.id);
    }
    return null;
}

export const userIsStaff = (state) => {
    const { userProfile } = state.user;
    return userProfile && userProfile.isStaff;
}

export const userIsAdmin = (state) => {
    const { userProfile } = state.user;
    return userProfile && (
        userProfile.isAdmin ||
        userProfile.isSuperuser ||
        userProfile.isSiteAdmin ||
        userProfile.isStudioTeacher
    );
}

export const userIsInStudio = (state) => {
    return state.user.userProfile?.memberOfCurrentStudio || false;
}

export const postIsInStudio = (state, post) => {
    const currentStudio = state.appState.currentStudio;
    if (!post || !currentStudio) {
        return false;
    }

    if (post.studio === currentStudio.id || post.sharedAccess.includes(currentStudio.id)) {
        return true;
    }

    if(post.communities.length) {
        const match = intersection(map(currentStudio.communities, c => c.id), post.communities);
        return !!match.length;
    }
}

export const userIsAdminOrStaff = (state) => {
    // catches all of the above
    return userIsStaff(state) || userIsAdmin(state);
}

export const isUserInGroup = (state, groupId, isPrivate=false) => {
    if (userIsAdmin(state)) {
        return true;
    }

    const userStudio = getUserStudio(state);
    if(userStudio) {
        if (isPrivate) {
            return !!find(userStudio.privateGroups, { id: groupId });
        } else {
            return !!find(userStudio.groups, { id: groupId });
        }
    }
    return false;
}

export const userCanEditItem = (state, item) => {
    // Check post, event, etc. for same user or admin.
    if (userIsAdmin(state)) {
        return true;
    }

    return item?.user?.id === state.user.userProfile.id;
}

export const getPendingSubscription = (state) => {
    const { userProfile } = state.user;
    if(!userProfile) {
        return null;
    }

    return find(userProfile.subscriptions, { status: "pending"});
}

export const getConnectedAccount = (subscription) => {
    if (!subscription) {
        return null;
    }

    return subscription.studioSubscription?.connectedAccount?.stripeId || null;
}
